var __jsx = React.createElement;
import React from "react";
import { BottomSheet } from "@componentsShared/BottomSheet";
import { Drawer, DrawerClose, DrawerContent, DrawerHeader } from "@/components/Drawer";
import { Icon } from "@syarahtech/ui";
import useIsMobile from "@hooks/useIsMobile";
import { Conditional } from "@componentsShared/Conditional/Conditional";
import { Then } from "@componentsShared/Conditional/Then";
import { Else } from "@componentsShared/Conditional/Else";
import ReusableBtn from "@/pages/checkout/bnpl/common/components/ReusableBtn";
import { twMerge } from "tailwind-merge";
import { useTranslation } from "@i18n";
var InfoModalContent = function InfoModalContent(_ref) {
  var icon = _ref.icon,
    title = _ref.title,
    text = _ref.text,
    titleClassNames = _ref.titleClassNames,
    descriptionClassNames = _ref.descriptionClassNames,
    primaryButton = _ref.primaryButton,
    secondaryButton = _ref.secondaryButton,
    confirmationButton = _ref.confirmationButton;
  // Default icon if none provided
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col justify-center  p-6 "
  }, icon && /*#__PURE__*/React.createElement("div", {
    className: "mb-6 flex  justify-center items-center "
  }, icon), /*#__PURE__*/React.createElement("h2", {
    className: twMerge(titleClassNames ? titleClassNames : "text-xl font-bold text-[#154f9c] mb-4 text-center")
  }, title), /*#__PURE__*/React.createElement("p", {
    className: twMerge(descriptionClassNames ? descriptionClassNames : "text-gray-600 text-sm max-w-md mb-6 text-center md:mx-6 leading-6")
  }, text), (primaryButton || secondaryButton) && /*#__PURE__*/React.createElement("div", {
    className: "space-y-3 w-full max-w-sm mx-auto"
  }, primaryButton && /*#__PURE__*/React.createElement(ReusableBtn, {
    label: primaryButton.label,
    onClick: primaryButton.onClick,
    variant: "fill"
  }), secondaryButton && /*#__PURE__*/React.createElement(ReusableBtn, {
    label: secondaryButton.label,
    onClick: secondaryButton.onClick,
    variant: "outline"
  }), confirmationButton && /*#__PURE__*/React.createElement(ReusableBtn, {
    label: confirmationButton.label,
    onClick: confirmationButton.onClick,
    variant: "custom",
    borderColor: "#D83434",
    textColor: "#D83434"
  })));
};
function InfoModal(_ref2) {
  var open = _ref2.open,
    onClose = _ref2.onClose,
    toggle = _ref2.toggle,
    title = _ref2.title,
    icon = _ref2.icon,
    text = _ref2.text,
    titleClassNames = _ref2.titleClassNames,
    primaryButton = _ref2.primaryButton,
    secondaryButton = _ref2.secondaryButton,
    confirmationButton = _ref2.confirmationButton;
  var isMobile = useIsMobile();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Conditional, {
    condition: !isMobile
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement(BottomSheet, {
    open: open,
    onOpen: function onOpen() {},
    onClose: onClose,
    maxHeight: "60%",
    maxHeightDesktop: "60%",
    hideTitleBar: true,
    screens: [{
      title: "",
      component: /*#__PURE__*/React.createElement(InfoModalContent, {
        icon: icon,
        title: title,
        text: text,
        titleClassNames: titleClassNames,
        primaryButton: primaryButton,
        secondaryButton: secondaryButton,
        confirmationButton: confirmationButton
      })
    }]
  })), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement("div", {
    className: "bg-white"
  }, /*#__PURE__*/React.createElement(Drawer, {
    open: open,
    onOpenChange: toggle,
    repositionInputs: false,
    preventScrollRestoration: true
  }, /*#__PURE__*/React.createElement(DrawerContent, {
    className: "max-h-[110vh] z-[9999999]"
  }, /*#__PURE__*/React.createElement(DrawerHeader, {
    className: "bg-white p-0 rounded-t-lg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center px-3 py-4 justify-end"
  }, /*#__PURE__*/React.createElement(DrawerClose, {
    asChild: true
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": t("close"),
    className: "p-0 rounded-full bg-transparent outline-none border-none w-6 h-6"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--close-small-outline-rounded",
    className: "text-gray-text",
    height: 6,
    width: 6
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "overflow-y-auto flex-1 max-h-fit bg-white"
  }, /*#__PURE__*/React.createElement(InfoModalContent, {
    icon: icon,
    title: title,
    text: text,
    titleClassNames: titleClassNames,
    primaryButton: primaryButton,
    secondaryButton: secondaryButton,
    confirmationButton: confirmationButton
  })))))));
}
export default InfoModal;